import { jsx as _jsx } from "react/jsx-runtime";
import { HStack, Skeleton } from '@chakra-ui/react';
import { FLAME_SLOTS, isPositiveMatchTier, litFlameCount, matchScoreToTier } from '../../lib/flames';
import { FlameMark } from './FlameMark';
/** Mark size per surface density: dashboard list, companion panel, creator card, sheet. */
export const flamePx = { xs: 13, panel: 16, sm: 17, md: 22 };
/**
 * The fit indicator of every creator surface: three flame slots, the lit
 * ones orange. The single implementation of the mark; the dashboard wraps it
 * with its tooltip and translations. Renders nothing for an unfit or unknown
 * match, and never the score.
 */
export function MatchFlames({ tier, score, size = 'sm', ariaLabel, title, ...stackProps }) {
    const resolvedTier = tier ?? matchScoreToTier(score);
    if (!isPositiveMatchTier(resolvedTier))
        return null;
    const lit = litFlameCount[resolvedTier];
    const labelled = Boolean(ariaLabel);
    return (_jsx(HStack, { as: "span", display: "inline-flex", align: "center", justify: "center", gap: "0.5", flexShrink: 0, "data-tier": resolvedTier, role: labelled ? 'img' : undefined, "aria-label": ariaLabel, "aria-hidden": labelled ? undefined : true, title: title, ...stackProps, children: Array.from({ length: FLAME_SLOTS }, (_, index) => (_jsx(FlameMark, { lit: index < lit, px: flamePx[size] }, index))) }));
}
/**
 * Loading placeholder for the scale. It reads its slot count and its per-slot
 * size from the same constants as the mark, so the row cannot jump when the
 * data lands.
 */
export function MatchFlamesSkeleton({ size = 'sm', ...stackProps }) {
    return (_jsx(HStack, { as: "span", display: "inline-flex", align: "center", gap: "0.5", flexShrink: 0, "aria-hidden": "true", ...stackProps, children: Array.from({ length: FLAME_SLOTS }, (_, index) => (_jsx(Skeleton, { width: `${flamePx[size]}px`, height: `${flamePx[size]}px`, borderRadius: "xs" }, index))) }));
}
